export const REGIONS = {
  US: "US",
  CA: "CA",
  UKROI: "UKROI",
};

export const REGION_OPTIONS = [
  { value: REGIONS.US, label: "United States" },
  { value: REGIONS.CA, label: "Canada" },
  { value: REGIONS.UKROI, label: "United Kingdom & Ireland" },
];

const KEY = "evon_region";

export function getStoredRegion() {
  try {
    const value = window.localStorage.getItem(KEY);
    return Object.values(REGIONS).includes(value) ? value : null;
  } catch {
    return null;
  }
}

export function setStoredRegion(region) {
  if (!Object.values(REGIONS).includes(region)) return;
  try {
    window.localStorage.setItem(KEY, region);
  } catch {
    // Keep the current selection for this session when storage is unavailable.
  }
}

export function guessRegion() {
  const language = (navigator.language || "").toLowerCase();
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";

  if (language.includes("en-ie") || language.includes("en-gb") || timeZone === "Europe/Dublin" || timeZone === "Europe/London") return REGIONS.UKROI;
  if (language.includes("en-ca") || language.includes("fr-ca")) return REGIONS.CA;
  if (language.includes("en-us") || timeZone.startsWith("America/")) return REGIONS.US;

  return REGIONS.US;
}

export function getRegion() {
  return getStoredRegion() || guessRegion();
}
